import { createFakeRegistryItems, createRegistry, } from "@aviv-unified-frontend/registry";
import { REAL_ITEMS } from "./data/real";
export const registry = createRegistry(process.env.ENVIRONMENT !== "local" && process.env.ENVIRONMENT !== "dev"
    ? REAL_ITEMS
    : createFakeRegistryItems(
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./data/fake").FAKE_ITEMS, REAL_ITEMS));
